export class FetchCatalog {
  static readonly type = '[Catalog] FetchCatalog';
}
